module.exports = __webpack_public_path__ + "4ee3b9ee38cb73dfa620cbe2f750fc05.fbx";